import styled from 'styled-components';
import { Icon } from 'components/shared';

const StyledButtonBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 10px;
  align-items: flex-start;
  background-color: transparent;
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

const StyledTitle = styled.h2`
  font-size: var(--font-size-s);
  font-weight: 600;
  font-family: 'Manrope', sans-serif;
  color: var(--color-primary);
  text-align: center;
  padding-bottom: 0.75rem;
`;

const StyledSubtitle = styled.h3`
  font-size: var(--font-size-xs);
  font-weight: 500;
  font-family: 'Manrope', sans-serif;
  color: var(--color-primary);
  text-align: center;
  padding-bottom: 0.75rem;
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  width: 100%;
  margin-bottom: 1rem;
`;

const StyledInfoWindow = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  background-color: white;
  box-shadow: 0px 0px 4px 1px rgba(15, 23, 39, 0.1);
  padding: 1.5rem; 
  flex: 1;
  min-width: 0; 
  @media (max-width: 768px) {
    align-items: center;
  }
`;

const StyledIcon = styled(Icon)`
  margin-right: 0.5rem;
  color: #fff;
`;

const StyledCloseIcon = styled(Icon)`
  color: var(--color-primary);
  cursor: pointer;
  margin-top: -1rem;
  margin-left: -1rem;
`;

const WhiteIcon = styled(Icon)`
  margin-right: 0.5rem;
  color: #fff;
`;

const UploadAndDownoadButtons = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  font-size: 0.875rem; 
  font-weight: 400; 
  outline: none;
  height: 2.25rem;
  min-width: 8rem;
  width: 15rem;
  padding: 0.5rem 1rem;
  background-color: #395905; 
  color: #fff;  
  cursor: pointer; 
  border: none;

  &:hover {
    background-color: #052959;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const PopoverWrapper = styled.div`
  position: absolute;
  min-width: max-content;
  z-index: 50;
  bottom: -140px;
  left: 0;
`;

const PopoverContent = styled.div`
  z-index: 50;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb;
  background: #fff;
  padding: 1rem;
  color: var(--color-secondary-text);
  box-shadow: 0 4px 24px 0 rgba(0,0,0,0.08), 0 1.5px 4px 0 rgba(0,0,0,0.03);
  outline: none;
  width: 20rem;
`;

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Title = styled.h4`
  font-weight: 500;
  margin: 0;
`;

const Description = styled.p`
  font-size: 0.875rem;
  color: var(--color-secondary-text);
  margin: 0;
`;

const DownloadButton = styled.button`
  font-family: 'Montserrat', sans-serif;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  font-size: 0.875rem; 
  font-weight: 700; 
  outline: none;
  height: 2.25rem;
  padding: 0.5rem 1rem; 
  width: 100%; 
  background-color: #395905; 
  color: #fff;  
  cursor: pointer; 
  border: none;

  &:hover {
    background-color: #052959;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
const StyledScheduleImport = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`;

const StyledScheduleImportBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const StyledScheduleImportForm = styled.div`
  position: relative;
`;

const CircularProgressOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const WaterProgressContainer = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.3);
`;

const WaterFill = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #052959;
  height: ${props => props.progress || 0}%;
  transition: height 0.5s ease-in-out;
  
  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: 0;
    right: 0;
    height: 4px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    animation: wave 2s ease-in-out infinite;
  }

  @keyframes wave {
    0%, 100% {
      transform: translateX(0) scaleX(1);
      opacity: 0.6;
    }
    50% {
      transform: translateX(-3px) scaleX(1.05);
      opacity: 0.8;
    }
  }
`;

const WaterProgressText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-weight: 600;
  font-size: 0.875rem;
  text-align: center;
  z-index: 2;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary);
  
  &:hover {
    color: var(--color-primary);
  }
`;

const PopoverHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`;

export {
  PopoverHeader,
  StyledButtonBlock,
  StyledSubtitle,
  UploadAndDownoadButtons,
  PopoverWrapper,
  PopoverContent,
  FlexCol,
  Title,
  Description,
  DownloadButton,
  Wrapper,
  StyledIcon,
  WhiteIcon,
  StyledScheduleImport,
  StyledScheduleImportBlock,
  StyledScheduleImportForm,
  CircularProgressOverlay,
  WaterProgressContainer,
  WaterFill,
  WaterProgressText,
  StyledInfoWindow,
  StyledTitle,
  StyledHeader,
  CloseButton,
  StyledCloseIcon,
};
